import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.querySelectorAll("table").forEach(table => {
      const tbody = table.querySelector("tbody");
      const hasRows = tbody && tbody.querySelector("tr");
      if (!hasRows) {
        table.remove();
      }
    });
  }
}
